import { Component } from 'react';

// Qualquer erro no pet (sem WebGL, pacote do three.js que não baixou) só some com
// o pet. O ErrorBoundary do app recarrega a página, o que aqui seria errado.
export default class LimitePet extends Component {
  constructor(props) {
    super(props);
    this.state = { falhou: false };
  }

  static getDerivedStateFromError() {
    return { falhou: true };
  }

  render() {
    return this.state.falhou ? null : this.props.children;
  }
}
